<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs2-14",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 34,
      nextPage: '/questionnaire/section2/15',
      navigateType: 'CLICK_ANY_BTN',
      content: {
        componentsType: {
          pc: 'longBtn',
          mobile: 'normalBtn'
        },
        titleIcon: require('@/assets/icon/questionIcon/21-Emotion.png'),
        mainTitle: 'How is your sleep?',
        btn: [
          [
            {
              text: 'Good',
            }
          ],[
            {
              text: 'General',
            }
          ],[
            {
              text: 'Not good',
            }
          ]
        ]
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
